import React from 'react';
import { Link } from 'react-router-dom';
import './Pages.css';

function QualityPage() {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Quality & Compliance</h1>
        <div className="title-underline"></div>
      </div>
      
      <div className="page-intro">
        <p>At HOPE INTERNATIONAL, quality and buyer trust are our priority. We work with verified suppliers and provide batch-level documentation to support global import requirements.</p>
      </div>

      <div className="quality-sections">
        <div className="quality-block">
          <h3>Batch-wise Quality Checks</h3>
          <p>All shipments are supplied with batch identification for smooth buyer verification and traceability.</p>
        </div>

        <div className="quality-block">
          <h3>Documentation Support</h3>
          <p>Documents available based on product and country requirements:</p>
          <ul>
            <li>Certificate of Analysis (COA) – available on request</li>
            <li>MSDS (Safety Data Sheet) – available on request</li>
            <li>Certificate of Origin – available</li>
            <li>Packing List & Commercial Invoice – available</li>
            <li>Phytosanitary documentation (if applicable)</li>
          </ul>
        </div>

        <div className="quality-block">
          <h3>Compliance & Safety Focus</h3>
          <p>We prioritize clean processing, safe packaging, and quality handling practices to meet importer expectations.</p>
        </div>

        <div className="quality-block">
          <h3>Traceability</h3>
          <p>We maintain a batch/lot reference system to help buyers track shipments and ensure consistent supply.</p>
        </div>
      </div>

      <div className="page-disclaimer">
        <p><strong>Note:</strong> Certifications and lab reports may vary depending on product batch and supplier documentation.</p>
      </div>

      <div className="page-cta-section">
        <h3>Need COA or technical specifications for evaluation?</h3>
        <div className="cta-buttons">
          <Link to="/request-coa" className="btn-primary">Request COA / Specs</Link>
          <Link to="/request-quote" className="btn-secondary">Request a Quote</Link>
        </div>
      </div>
    </div>
  );
}

export default QualityPage;
